import React from "react";
import { message, Spin } from "antd";
import Button from "../../components/Button";
import Bridge from "../../constants/Bridge";
import URLs, { BASE_URL } from "../../constants/Apis";

class ForgotPassword extends React.Component {
  // state list
  state = {
    email: "",
    password: "",
    loading: false,
    type1: "password",
  };
  // login

  validateEmail = (email) => {
    // Regular expression for validating email addresses
    var regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    // Test the email against the regex pattern
    return regex.test(email);
  };
  // send otp
  sendOtp = () => {
    var isValid = this.validateEmail(this.state.email);
    if (!this.state.email) {
      message.warning("Email address is required");
      return;
    } else if (!isValid) {
      message.warning("Email address format is not valid");
      return;
    }
    let params = {
      email: this.state.email,
    };
    this.setState({ loading: true });
    Bridge.forgotPassword
      .sendOtp(params)
      .then((res) => {
        if (res.status == 1) {
          localStorage.setItem("forgot_email", this.state.email);
          this.setState({ loading: false }, () =>
            window.location.assign("/verify-otp")
          );
          message.success(res.message);
        } else {
          message.warning(res.message);
          this.setState({ loading: false });
          return;
        }
      })
      .catch((err) => {
        message.warning("Something went wrong. Please try again.");
        this.setState({ loading: false });
      });
  };

  // on change inputs
  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };
  // show hide password
  togglePassword = (num) => {
    if (num == "1") {
      this.setState({
        type1: this.state.type1 == "password" ? "text" : "password",
      });
    }
  };

  render() {
    const forgotPassLinkStyle = {
      textDecoration: "none",
      color: "#546adf",
      position: "relative",
      top: -10,
      fontWeight: "600",
      fontSize: 15,
    };
    return (
      <div
        className="multisteps-form__panel js-active login-page"
        data-animation="slideVert"
      >
        <div className="inner pb-50">
          <div
            className="wizard-content-item text-center"
            style={{ paddingTop: 0 }}
          >
            <div
              className="wizard-content-item text-center"
              style={{ paddingTop: 0 }}
            >
              <img
                src="/assets/img/ecas-logo-white.png"
                className="logo-img"
                style={{
                  margin: "0 auto",
                  marginBottom: 0,
                  maxWidth: 220,
                  width: 240,
                }}
              />
              <h2>
                EALS Consortia Portal
                <br /> Forgot Password
              </h2>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-4 m-auto">
              <div className="wizard-content-form">
                <Spin spinning={this.state.loading}>
                  <div className="wizard-form-field">
                    <div className="wizard-form-input  position-relative form-group has-float-label">
                      <input
                        type="text"
                        className="form-control"
                        name="email"
                        placeholder="Email Address"
                        value={this.state.email}
                        onChange={this.handleChange}
                      />
                      <label>Email Address</label>
                    </div>
                    <center>
                      <Button
                        to="#"
                        isClickable={true}
                        click={() => this.sendOtp()}
                        style={{ width: "fit-content" }}
                      >
                        <i className="fa fa-arrow-right" aria-hidden="true"></i>
                        &nbsp;&nbsp; Send Verification Code
                      </Button>
                    </center>
                  </div>
                </Spin>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default ForgotPassword;
